import React, { useState } from "react";
import axios from "axios";
import { showAlert } from "../../common/sweetalert/sweetalert";
import { serverLink } from "../../../resources/url";
import { toast } from "react-toastify";
import DepartmentSelectOption from "../../common/dynamic-select-option/department-select-option";
import ProgrammeSelectOption from "../../common/dynamic-select-option/progrmme-select-option";

export default function BulkCourseUploadModal(props) {
    const [bulkData, setBulkData] = useState({
        LEVEL: "",
        SEMESTER: "",
        DEPARTMENT_ID: "",
        PROG_ID: "",
    });
    const [file, setFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    const onEdit = (e) => {
        setBulkData({
            ...bulkData,
            [e.target.id]: e.target.value,
        });
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const downloadTemplate = (e) => {
        e.preventDefault();
        const headers = "COURSE_CODE,COURSE_TITLE,CREDIT_UNIT";
        const blob = new Blob([headers], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        a.setAttribute("download", "course_bulk_upload_template.csv");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const handleUpload = async () => {
        if (!bulkData.LEVEL || !bulkData.SEMESTER || !bulkData.DEPARTMENT_ID || !bulkData.PROG_ID) {
            showAlert("EMPTY FIELD", "Please select Level, Semester, Department, and Programme", "error");
            return;
        }

        if (!file) {
            showAlert("NO FILE", "Please select a CSV file to upload", "error");
            return;
        }

        setIsUploading(true);

        const reader = new FileReader();
        reader.onload = async (e) => {
            const text = e.target.result;
            const rows = text.split("\n");
            const courses = [];

            // Skip header
            for (let i = 1; i < rows.length; i++) {
                if (rows[i].trim() === "") continue;

                // Simple CSV parsing (handling basic comma separation)
                // For more complex cases, a library would be better, but this matches the "template should only have" requirement
                const cols = rows[i].split(",");
                if (cols.length >= 2) {
                    courses.push({
                        COURSE_CODE: cols[0]?.trim(),
                        COURSE_TITLE: cols[1]?.trim(),
                        CREDIT_UNIT: cols[2]?.trim() || "0",
                    });
                }
            }

            if (courses.length === 0) {
                showAlert("EMPTY FILE", "No course data found in the file", "error");
                setIsUploading(false);
                return;
            }

            const sendData = {
                ...bulkData,
                courses: courses,
                INSERTED_BY: props.loginData[0] ? `${props.loginData[0].FirstName} ${props.loginData[0].MiddleName} ${props.loginData[0].Surname}` : "Admin",
            };

            await axios
                .post(`${serverLink}staff/academics/course/bulk-add`, sendData)
                .then((result) => {
                    if (result.data.message === "success") {
                        toast.success(`Upload complete! Added: ${result.data.addedCount}, Skipped: ${result.data.skippedCount}`);
                        setIsUploading(false);
                        props.getData(); // Refresh the list
                        document.getElementById("closeBulkModal").click();
                    } else {
                        setIsUploading(false);
                        showAlert("ERROR", "Something went wrong. Please try again!", "error");
                    }
                })
                .catch((error) => {
                    setIsUploading(false);
                    showAlert("NETWORK ERROR", "Please check your connection and try again!", "error");
                });
        };
        reader.readAsText(file);
    };

    return (
        <div className="modal modal-blur fade" id="modal-bulk-upload" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Bulk Course Upload</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12 mb-3">
                                <div className="alert alert-info">
                                    <h4 className="alert-title">Instructions</h4>
                                    <p>1. Download the CSV template below.</p>
                                    <p>2. Fill in the COURSE_CODE, COURSE_TITLE, and CREDIT_UNIT.</p>
                                    <p>3. Select the common Level, Semester, Department, and Programme for the courses.</p>
                                    <p>4. Upload the file.</p>
                                    <a href="#" onClick={downloadTemplate} className="btn btn-sm btn-info mt-2">
                                        Download CSV Template
                                    </a>
                                </div>
                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Department</label>
                                <DepartmentSelectOption formData={bulkData} setFormData={setBulkData} />
                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Programme</label>
                                <ProgrammeSelectOption formData={bulkData} setFormData={setBulkData} />
                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Level</label>
                                <select className="form-control" name="LEVEL" id="LEVEL" value={bulkData.LEVEL} onChange={onEdit}>
                                    <option value="">Select Course Level</option>
                                    <option value="1">ND-1</option>
                                    <option value="2">ND-2</option>
                                    <option value="3">HND-1</option>
                                    <option value="4">HND-2</option>
                                </select>
                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Semester</label>
                                <select className="form-control" name="SEMESTER" id="SEMESTER" value={bulkData.SEMESTER} onChange={onEdit}>
                                    <option value="">Select Course Semester</option>
                                    <option value="1">First Semester</option>
                                    <option value="2">Second Semester</option>
                                </select>
                            </div>

                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Select CSV File</label>
                                <input type="file" className="form-control" accept=".csv" onChange={handleFileChange} />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <a href="#" id="closeBulkModal" className="btn btn-link link-secondary" data-bs-dismiss="modal">
                            Cancel
                        </a>
                        {isUploading ? (
                            <button type="button" className="btn btn-primary ms-auto" disabled>
                                <span>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" /> Uploading...
                                </span>
                            </button>
                        ) : (
                            <button type="button" onClick={handleUpload} className="btn btn-primary ms-auto">
                                <span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="icon"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        strokeWidth="2"
                                        stroke="currentColor"
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                        <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" />
                                        <polyline points="7 9 12 4 17 9" />
                                        <line x1="12" y1="4" x2="12" y2="16" />
                                    </svg>
                                    Upload Courses
                                </span>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
